/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import styled from 'styled-components';
import Colors from 'constants/Colors';

export const AttachmentContainer = styled.section`
border: 1px solid ${Colors.BLUE};
background: #fff;
margin-bottom: 40px;
height: 200px;
overFlow: auto;
width: 100%;
`;
